<template>
  <div
    :class="[
      'sliderTiles',
      `sliderTiles--${contentType}`,
      {
        'sliderTiles--noBreakpoints':
          typeof breakpoints === 'object' ? !Object.keys(breakpoints).length : true,
        'sliderTiles--noNegativeMargins': spaceBetween > 0,
        'sliderTiles--withRightControls': rightControls,
        'flexibleSliderSection--loading': loading,
      },
    ]"
  >
    <SwiperSlider ref="sliderTiles" class="sliderTiles__slider" :options="swiperOptions">
      <div v-for="(item, index) in items" :key="index" class="sliderTiles__slide swiper-slide">
        <product-tile
          :disable-native-link="disableNativeLink"
          :product="item"
          v-if="contentType === 'product'"
        />
        <blog-tile :item="item" v-if="contentType === 'news'" />
        <small-blog-tile :item="item" v-if="contentType === 'small-news'" />
      </div>
    </SwiperSlider>
    <SliderButton
      position="prev"
      :right-controls="rightControls"
      @click="prevEl"
      :disabled="prevDisable && watchOverflow"
    />
    <SliderButton
      position="next"
      :button-type="navButtonsType"
      :right-controls="rightControls"
      @click="nextEl"
      :disabled="nextDisable && watchOverflow"
    />

    <loader v-if="loading" />
  </div>
</template>

<script>
import SwiperSlider from '~/components/SwiperSlider';
import ProductTile from '~/components/Product/ProductTile';
import BlogTile from '~/components/Blog/BlogTile';
import Loader from '~/components/Loader';
import SmallBlogTile from '@/components/Blog/SmallBlogTile';
import SliderButton from '@/components/Sliders/SliderButton.vue';

export default {
  name: 'SliderTiles',
  components: {
    SliderButton,
    SmallBlogTile,
    Loader,
    ProductTile,
    BlogTile,
    SwiperSlider,
  },
  props: {
    disableNativeLink: {
      type: Boolean,
      default: false,
    },
    contentType: {
      type: String,
      default: 'product',
    },
    items: {
      type: Array,
      default: () => [],
    },
    slidesPerView: {
      type: [Number, String],
      default: 4,
    },
    watchOverflow: {
      type: Boolean,
      default: true,
    },
    breakpoints: {
      type: Object,
      default: () => {},
    },
    rightControls: {
      type: Boolean,
      default: false,
    },
    navButtonsType: {
      type: String,
      default: 'arrows',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    spaceBetween: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      nextDisable: false,
      prevDisable: false,
      swiperOptions: {
        slidesPerView: this.slidesPerView,
        loop: false,
        speed: 600,
        spaceBetween: this.spaceBetween,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 4,
        },
        navigation: true,
        breakpoints: this.breakpoints,
      },
    };
  },
  computed: {
    swiper() {
      if (typeof this.$refs.sliderTiles.swiper !== 'undefined') {
        return this.$refs.sliderTiles.swiper;
      }
      return false;
    },
  },
  mounted() {
    if (this.swiper) {
      this.swiper.on('slideChange', () => {
        this.checkArrows();
      });

      this.swiper.once('update', () => {
        this.swiper.on('slideChange', () => {
          this.checkArrows();
        });
      });

      this.checkArrows();
    }
  },
  methods: {
    refreshSlider() {
      this.swiper.update();
      this.checkArrows();
    },
    checkArrows() {
      this.nextDisable = this.swiper.isEnd;
      this.prevDisable = this.swiper.activeIndex === 0;
    },
    prevEl() {
      if (this.swiper) {
        this.swiper.slidePrev();
      }
    },
    nextEl() {
      if (this.swiper) {
        this.swiper.slideNext();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sliderTiles {
  $root: &;
  position: relative;
  margin: 0 -8px;

  &__slide {
    height: auto;
    padding-left: 8px;
    padding-right: 8px;
  }

  &--withRightControls {
    @include rwd('large-tablet', true) {
      padding-right: 6.4rem;
    }
  }

  &--noBreakpoints {
    #{$root}__slide {
      @include rwd('small-tablet', true) {
        width: 50% !important;
      }

      @include rwd('large-tablet', true) {
        width: 33.333% !important;
      }

      @include rwd('large-laptop', true) {
        width: 25% !important;
      }
    }
  }

  &--noNegativeMargins {
    margin: 0;

    #{$root}__slide {
      padding: 0;
    }
  }
}
</style>
